var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":_vm.isLoading,"z-index":2000},on:{"update:active":function($event){_vm.isLoading=$event}}},[_c('div',{staticClass:"loader"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }